module.exports = __webpack_public_path__ + "img/DSJFX_title.5cff89c3.svg";